import { Component } from '@angular/core';

@Component({
  selector: 'app-preview-header',
  templateUrl: './preview-header.component.html'
})
export class PreviewHeaderComponent {
}
